<div class="container">
  <app-drawer-workorder-title
    title="{{ 'workorder.not-mine.title' | translate }}"
    [externalId]="workOrder.externalId"
    [clientName]="workOrder.clientName"
  ></app-drawer-workorder-title>
  <div class="not-mine-content">
    <p>
      {{ "workorder.not-mine.description" | translate }}
    </p>
    <p>{{ "workorder.not-mine.suggest-supervisor" | translate }}</p>
    <h3>{{ "workorder.not-mine.search-title" | translate }}</h3>
    <div class="search">
      <input
        #search
        class="search-text"
        type="text"
        placeholder="{{ 'workorder.not-mine.search' | translate }}"
        [formControl]="suggestedSupervisorControl"
        [matAutocomplete]="auto"
        (keyup)="updateSearchTerm(search.value)"
        onClick="this.select();"
      />
      <mat-icon class="search-icon">search</mat-icon>
    </div>
    <mat-autocomplete
      #auto="matAutocomplete"
      [displayWith]="displayEmployee"
      autoActiveFirstOption="true"
    >
      <mat-option
        *ngFor="let supervisor of supervisors$ | async"
        [value]="supervisor"
      >
        {{ supervisor.name }}
      </mat-option>
    </mat-autocomplete>
    <div class="actions-question">
      <p>{{ "workorder.not-mine.confirm-question" | translate }}</p>
    </div>
  </div>

  <app-drawer-workorder-actions
    confirmButtonName="{{ 'workorder.not-mine.yes' | translate }}"
    (clickConfirmButtonEvent)="confirm()"
    (clickCancelButtonEvent)="close()"
  ></app-drawer-workorder-actions>
</div>
